import styled, { css } from 'styled-components';
import { colors, media } from 'tsx/theme';

const Div = styled.div`
  height: 23px;
  width: 23px;
  min-width: 23px;
  border: 1px solid black;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 2px;

  .checked {
    height: 100%;
    min-width: 100%;
    background-color: ${colors.verdigris};
  }

  ${media.md(css`
    height: 18px;
    width: 18px;
    min-width: 18px;
  `)};
`;

interface CheckBoxProps {
  checked?: boolean;
  onSelect: (a: boolean) => void;
}

export const CheckBoxVerdigris: React.FC<CheckBoxProps> = ({ checked, onSelect }) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onSelect(!checked);
    }
  };
  return (
    <Div
      onClick={() => onSelect(!checked)}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="checkbox"
      aria-label="Checkbox"
      aria-checked={checked}
    >
      {checked && <div className="checked" />}
    </Div>
  );
};
